<template>
	<div id="pdf">
		<span class="back" @click="goBack">
			<van-icon name="arrow-left" />
		</span>
		<div id="demo"></div>
	</div>
</template>
<script>
import Pdfh5 from 'pdfh5';
export default {
	name: 'App',
	data() {
		return {
			pdfh5: null,
		};
	},
	mounted() {
		//实例化
		this.pdfh5 = new Pdfh5('#demo', {
			pdfurl: window.localStorage.getItem('fileUrl'),
		});
		//监听完成事件
		this.pdfh5.on('complete', function(status, msg, time) {
			console.log('状态：' + status + '，信息：' + msg + '，耗时：' + time + '毫秒，总页数：' + this.totalNum);
		});
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
	},
};
</script>

<style scoped lang="less">
@import '../assets/pdfh5.css';
/* @import "pdfh5/css/pdfh5.css"; */
#pdf {
	height: 100%;
	.back .van-icon {
		font-size: 20px;
		color: #888;
		margin-left: -5px;
	}
	background: #fff;
	padding: 0 16px;
	.loading {
		margin-top: 240px;
	}
}
</style>
